// eslint-disable-next-line no-restricted-imports
import { Pagination } from '@mui/material';

import { CSSObject, styled } from '../styled';
import { Colors } from '../theme';

export const PaginationStyled = styled(Pagination)(({ theme }) => ({
  '.MuiPaginationItem-root': {
    transition: theme.transitions.create(['color', 'background', 'border']),

    '&:hover': {
      background: 'none',
      color: Colors.hover,
    },
  },
  '.MuiPaginationItem-outlined': {
    borderRadius: 8,
    border: `none`,
    background: 'none',

    height: 32,
    width: 32,
    color: Colors.black,
    fontSize: 14,

    '&.Mui-selected': {
      border: `1px solid ${Colors.gray300}`,
      background: Colors.white,
      '&:hover': {
        background: Colors.gray100,
        borderColor: Colors.gray400,
      },
    },
  } as CSSObject,

  '.MuiPaginationItem-ellipsis': {
    paddingTop: 6,
  },

  '.MuiPaginationItem-icon': {
    fontSize: 30,
    color: Colors.black,
    transition: theme.transitions.create(['color']),

    '&:hover': {
      color: Colors.hover,
    },
  },

  '.MuiButtonBase-root.Mui-disabled .MuiPaginationItem-icon': {
    color: Colors.gray300,
  },
}));
